import { MarketStatus } from '@velocity-exchange/sdk';
import { USDT_SPOT_MARKET_INDEX } from '@velocity-exchange/common';

export const MAX_SPOT_MARKETS_PER_USER = 8;
export const MAX_SPOT_POSITIONS_ERROR_MESSAGE = {
	title: 'Max spot positions/orders reached',
	message: `You have reached the maximum number of spot positions (${MAX_SPOT_MARKETS_PER_USER}) for a single user account. This includes spot balances and open orders. To add new positions, you can: cancel existing spot orders, close spot positions, or you can create a new subaccount.`,
};

/**
 * These extra tags can be searched for in the market search bar.
 * Perp markets has full names in their market config, so we don't need to add them here.
 */
export const MARKET_TAGS = {
	perp: {},
};

export type MarketCategory = 'all' | 'newAndTrending' | 'spot';

const COMMON_MARKET_CATEGORIES_CONFIG: {
	value: MarketCategory;
	label: string;
}[] = [
	{
		value: 'all',
		label: 'All Markets',
	},
];

const SPOT_MARKET_CATEGORY: {
	value: MarketCategory;
	label: string;
} = {
	value: 'spot',
	label: 'Spot',
};

export const PERP_MARKET_CATEGORIES_CONFIG: {
	value: MarketCategory;
	label: string;
}[] = [...COMMON_MARKET_CATEGORIES_CONFIG, SPOT_MARKET_CATEGORY];

export const HIDDEN_MARKET_STATUSES = [
	MarketStatus.DELISTED,
	MarketStatus.SETTLEMENT,
	MarketStatus.REDUCE_ONLY,
];

// Spot market index constants
export const VELOCITY_TOKEN_BANK_INDEX = 15;
export const DSOL_MARKET_INDEX = 17;
export const JLP_MARKET_INDEX = 19;

export const PRIORITY_SPOT_MARKETS: Record<number, number> = {
	[USDT_SPOT_MARKET_INDEX]: 0,
	[1]: 1, // SOL
	[DSOL_MARKET_INDEX]: 2,
	[JLP_MARKET_INDEX]: 3,
};
